var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { EvaluationLevel } from '../validatePassword';
import { Grid, Cell } from '../../../../Grid';
import formTheme from '../../../theme';
import { ComponentThemeProvider } from '../../../../ThemeProvider';
var InvalidText = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var component = _a.theme.component;
    return component.form.passwordStrength.text.invalid;
});
var WeakText = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var component = _a.theme.component;
    return component.form.passwordStrength.text.weak;
});
var MediumText = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var component = _a.theme.component;
    return component.form.passwordStrength.text.medium;
});
var StrongText = styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var component = _a.theme.component;
    return component.form.passwordStrength.text.strong;
});
var StyledGrid = styled(Grid)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var Indicator = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: inline-block;\n  background-color: grey;\n  border: 1px solid transparent;\n  border-radius: ", ";\n  width: 95%;\n  height: 0.5rem;\n  transition: all 1s ease;\n  ", "\n  ", "\n", "\n"], ["\n  display: inline-block;\n  background-color: grey;\n  border: 1px solid transparent;\n  border-radius: ", ";\n  width: 95%;\n  height: 0.5rem;\n  transition: all 1s ease;\n  ",
    "\n  ",
    "\n",
    "\n"])), function (_a) {
    var component = _a.theme.component;
    return component.form.borderRadius;
}, function (_a) {
    var component = _a.theme.component, level = _a.level;
    return level === EvaluationLevel.WEAK
        ? "background-color: " + component.form.passwordStrength.indicator.weak + ";"
        : '';
}, function (_a) {
    var component = _a.theme.component, level = _a.level;
    return level === EvaluationLevel.MEDIUM
        ? "background-color: " + component.form.passwordStrength.indicator.medium + ";"
        : '';
}, function (_a) {
    var component = _a.theme.component, level = _a.level;
    return level === EvaluationLevel.STRONG
        ? "background-color: " + component.form.passwordStrength.indicator.strong + ";"
        : '';
});
var FirstIndicator = function (_a) {
    var level = _a.level;
    switch (level) {
        case EvaluationLevel.MEDIUM:
            return React.createElement(Indicator, { "data-testid": "first-medium", level: EvaluationLevel.MEDIUM });
        case EvaluationLevel.STRONG:
            return React.createElement(Indicator, { "data-testid": "first-strong", level: EvaluationLevel.STRONG });
        case EvaluationLevel.WEAK:
            return React.createElement(Indicator, { "data-testid": "first-weak", level: EvaluationLevel.WEAK });
        default:
            return React.createElement(Indicator, { "data-testid": "first-default", level: EvaluationLevel.INVALID });
    }
};
var SecondIndicator = function (_a) {
    var level = _a.level;
    switch (level) {
        case EvaluationLevel.MEDIUM:
            return React.createElement(Indicator, { "data-testid": "second-medium", level: EvaluationLevel.MEDIUM });
        case EvaluationLevel.STRONG:
            return React.createElement(Indicator, { "data-testid": "second-strong", level: EvaluationLevel.STRONG });
        default:
            return React.createElement(Indicator, { "data-testid": "second-default", level: EvaluationLevel.INVALID });
    }
};
var ThirdIndicator = function (_a) {
    var level = _a.level;
    if (level === EvaluationLevel.STRONG) {
        return React.createElement(Indicator, { "data-testid": "third-strong", level: EvaluationLevel.STRONG });
    }
    return React.createElement(Indicator, { "data-testid": "third-default", level: EvaluationLevel.INVALID });
};
/* istanbul ignore next */
var neverCalled = function () { return React.createElement(React.Fragment, null); };
var PasswordStrengthText = function (_a) {
    var level = _a.level;
    switch (level) {
        case EvaluationLevel.INVALID:
            return (React.createElement(FormattedMessage, { id: "passwordstrength.invalid", defaultMessage: "invalid", tagName: InvalidText }));
        case EvaluationLevel.TOO_SHORT:
            return (React.createElement(FormattedMessage, { id: "passwordstrength.tooshort", defaultMessage: "too short", tagName: InvalidText }));
        case EvaluationLevel.TOO_LONG:
            return (React.createElement(FormattedMessage, { id: "passwordstrength.toolong", defaultMessage: "too long", tagName: InvalidText }));
        case EvaluationLevel.WEAK:
            return (React.createElement(FormattedMessage, { id: "passwordstrength.weak", defaultMessage: "weak", tagName: WeakText }));
        case EvaluationLevel.MEDIUM:
            return (React.createElement(FormattedMessage, { id: "passwordstrength.medium", defaultMessage: "medium", tagName: MediumText }));
        case EvaluationLevel.STRONG:
            return (React.createElement(FormattedMessage, { id: "passwordstrength.strong", defaultMessage: "strong", tagName: StrongText }));
        /*
           behold the magic!
           This branch will only be called when our switch doesn't have a case for all options,
           which will cause a build failure as neverCalled should never get a parameter (which is indicated by the never type above)
           This is excluded from test coverage as we can't build code that gets here without getting a compile time error
        */
        /* istanbul ignore next */
        default:
            return neverCalled(level);
    }
};
export var PasswordStrengthIndicator = function (_a) {
    var level = _a.level;
    return (React.createElement(ComponentThemeProvider, { theme: formTheme },
        React.createElement("div", { "data-testid": "password-strength-indicator" },
            React.createElement(StyledGrid, { cellsPerRow: [3] },
                React.createElement(Cell, null,
                    React.createElement(FirstIndicator, { level: level })),
                React.createElement(Cell, null,
                    React.createElement(SecondIndicator, { level: level })),
                React.createElement(Cell, null,
                    React.createElement(ThirdIndicator, { level: level }))),
            React.createElement(FormattedMessage, { id: "passwordstrength.prefix", defaultMessage: "password strength: " }),
            React.createElement(PasswordStrengthText, { level: level }))));
};
export default PasswordStrengthIndicator;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=index.js.map